// Copyright 2017 Sorama B.V.

export class MetadataValuePair {
    key: string;
    value: string;
}
